export default "__VITE_ASSET__090bf8d3__$_?component__"